import utils from '../../../common/utils'
import authenticationModalTemplate from './authenticationModalList.html'
import QRCode from 'qrcode'

class certificationModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, $uibModal) {
        httpRequest.get_SysParamMap().then(res => {
            let sys = res.data.value.sys;
            sys.forEach(item => {
                if (item.paramCode == 'sys_scan_code_auth') {
                    $scope.authType = item.paramValue
                }
            });
            if($scope.authType=='2'||$scope.authType=='1'){
                $scope.active = 2
            }else {
                $scope.active = 1
            }
            if ($scope.authorizeId) {
                $scope.refreshQrCode($scope.active)
            }
        });
        $scope.srcBase64 = ''
        // srcBase6'data:image/jpg;base64,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'
        $scope.showText = false
        $scope.showTextHtml = '二维码已失效' //二维码已超时
        $scope.attestationId = ''
        // 默认没有扫码
        // $scope.qrCodeStatus = '1'
        $scope.authorizeId = items1.authorizeId //税局授权账户 ID不能为空
        let queryQrCodeTimer
        $scope.refreshQrCode = function (type) {
            $scope.active = type
            if(!$scope.authorizeId){
                return logger.logError('税局授权账户ID为空')
            }
            let data = {
                authorizeId: $scope.authorizeId,
                invoiceNature: 0, //发票性质 不能为空
                qrcodeType: type
            }
            utils.loading('请求已发送')
            httpRequest.post_getQrCode(data).then((res) => {
                utils.loaded()
                if (res.data.value && res.data.value.qrCodeContext) {
                    if(type === 2){
                        if(res.data.value.qrCodeContext.indexOf('qrcode_id=') === -1){
                            $scope.srcBase64 =  'data:image/jpg;base64,'+res.data.value.qrCodeContext
                        }else {
                            QRCode.toDataURL(res.data.value.qrCodeContext).then((url) => {
                                $scope.srcBase64 = url
                            })
                        }
                    }else {
                        QRCode.toDataURL(res.data.value.qrCodeContext).then((url) => {
                            $scope.srcBase64 = url
                        })
                    }
                    $scope.attestationId = res.data.value.attestationId
                    $scope.showText = false
                    $scope.orgName = res.data.value.orgName
                    $scope.realName = res.data.value.realName
                    // loopQueryQrCodeStatus()   // 二维码定时任务自动刷新
                    $scope.queryQrCodeStatus3()
                } else if (res.data.msgCode === 2002 || res.data.msgCode === 2003) {
                    $uibModalInstance.dismiss()
                    logger.logSuccess(res.data.message)
                    $uibModal.open({
                        template: authenticationModalTemplate,
                        controller: 'authenticationModalCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items1() {
                                return {
                                    authorizeId: $scope.authorizeId,
                                    mobile: res.data.message.substring(10),
                                }
                            },
                        },
                    })
                } else if (res.data.msgCode === -99997) {
                    let data = {
                        mes:res.data.message,
                        code:1
                    }
                    $uibModalInstance.close(data)
                } else {
                    $scope.showText = true
                    $scope.showTextHtml = '二维码已超时'
                    logger.logError(res.data.message)
                    if(res.data.msgCode === 12100){
                        clearTimeout(queryQrCodeTimer)
                        $uibModalInstance.dismiss()
                    }
                }
            })
        }

        function loopQueryQrCodeStatus() {
            ;(function inner() {
                if (queryQrCodeTimer) clearTimeout(queryQrCodeTimer)
                let data = {
                    authorizeId: $scope.authorizeId,
                    invoiceNature: 0, //发票性质 不能为空
                    attestationId: $scope.attestationId,
                    qrcodeType: $scope.active
                }
                httpRequest.post_queryQrCodeStatus(data).then((res) => {
                    let qrCodeStatus = res.data.value.status

                    if (qrCodeStatus == '2') {
                        // 扫码认证通过
                        logger.logSuccess('扫码实名身份认证通过')
                        clearTimeout(queryQrCodeTimer)
                        $uibModalInstance.close('ok')
                        return
                    } else if (qrCodeStatus == '3') {
                        $scope.showText = true
                        $scope.showTextHtml = '二维码已失效'
                        logger.logError('二维码已过期，请重新刷新二维码')
                    }
                })

                queryQrCodeTimer = setTimeout(function () {
                    clearTimeout(queryQrCodeTimer)
                    inner()
                }, 30000)
            })()
        }
        $scope.queryQrCodeStatus3 = function () {
            let data = {
                authorizeId: $scope.authorizeId,
                invoiceNature: 0, //发票性质 不能为空
                attestationId: $scope.attestationId,
                qrcodeType: $scope.active
            }
            httpRequest.post_queryQrCodeStatus(data).then((res) => {
                let qrCodeStatus = res.data.value.status
                if (qrCodeStatus == '3') {
                    $scope.showText = true
                    $scope.showTextHtml = '二维码已失效'
                    logger.logError('二维码已过期，请重新刷新二维码')
                }
            })
        }

        $scope.queryQrCodeStatus = function () {
            let data = {
                authorizeId: $scope.authorizeId,
                invoiceNature: 0, //发票性质 不能为空
                attestationId: $scope.attestationId,
                qrcodeType: $scope.active
            }
            utils.loading('请求已发送')
            httpRequest.post_queryQrCodeStatus(data).then((res) => {
                utils.loaded()
                let qrCodeStatus = res.data.value.status

                if (qrCodeStatus == '2') {
                    // 扫码认证通过
                    logger.logSuccess('扫码实名身份认证通过')
                    clearTimeout(queryQrCodeTimer)
                    $uibModalInstance.close('ok')
                    $rootScope.$emit('certificationStatusChange')
                } else if (qrCodeStatus == '3') {
                    $scope.showText = true
                    $scope.showTextHtml = '二维码已失效'
                    logger.logError('二维码已过期，请重新刷新二维码')
                } else if (qrCodeStatus == '1') {
                    if($scope.active === 1){
                        logger.logError('当前状态为未扫码，请使用电子税务局APP扫码认证')
                    }else {
                        logger.logError('当前状态为未扫码，请使用个人所得税APP扫码认证')
                    }
                }
            })
        }

        $scope.ok = function () {
            $scope.queryQrCodeStatus()
        }
        $scope.cancel = function () {
            clearTimeout(queryQrCodeTimer)
            $uibModalInstance.dismiss()
        }
    }
}

certificationModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', '$uibModal']
export default certificationModalCtrl



// WEBPACK FOOTER //
// ./src/app/main/common/certificationModalCtrl.js